import React, { useState, useEffect, useRef } from "react";
import AuctionCardComponent from "../../Components/card/AuctionCard";
import AuctionResults from "./AuctionResults";
import { getAuncitonsWithPagination } from "../../services/aunction";
import useFetch from "../../hooks/useFetch";
import { auctionData } from "../../Components/BankAunctionData/aunction";
import { formatNumberUtil } from "../../Utils/localStorageUtils";
import MultiSelectComponent from "../../Components/MultiSelect/MultiSelect";

const BankAuctionPage2 = () => {
  const [sort, setSort] = useState(""); // highToLow/lowToHigh
  const [filters, setFilters] = useState({ propertyTypes: [], state: "", district: "" });

  // Use fetched data if available, otherwise fallback to local data
  let auctions = auctionData;

  // Apply property type filter
  if (filters.propertyTypes.length > 0) {
    auctions = auctions.filter((auction) =>
      filters.propertyTypes.includes(auction.propertyType.toUpperCase())
    );
  }

  // Apply state filter
  if (filters.state) {
    auctions = auctions.filter((auction) => auction.state.toUpperCase() === filters.state.toUpperCase());
  }

  // Apply district filter
  if (filters.district) {
    auctions = auctions.filter((auction) =>
      auction.district.toUpperCase() === filters.district.toUpperCase()
    );
  }



  // Apply sorting
  if (sort === "highToLow") {
    auctions = [...auctions].sort((a, b) => b.reservePrice - a.reservePrice);
  } else if (sort === "lowToHigh") {
    auctions = [...auctions].sort((a, b) => a.reservePrice - b.reservePrice);
  }

  return (
    <div className="bg-[#F8F8F8] ">
    <div className="py-[200px] max-w-5xl mx-auto ">

      <MultiSelectComponent onSelectionChange={setFilters} />

      {/* Filter and Sort Select Options */}
      <AuctionResults
        totalResults={auctions.length}
        onSortChange={setSort}
      />

      {/* Display Auctions or No Results Message */}
      {auctions.length > 0 ? (
        auctions.map((auction, index) => (
          <div key={auction.propertyId || index} className="py-2">
            <AuctionCardComponent
              bank={auction.bankName}
              location={`${auction.city}, ${auction.state}`}
              refNo={auction.propertyId}
              description={auction.summaryDescription}
              closingDate={auction.auctionCloseDate}
              emd={auction.emd}
              estimatedCost={auction.reservePrice}
              // price={`₹${(auction.reservePrice / 100000).toFixed(2)} Lacs`}
              price={`₹${formatNumberUtil(auction.reservePrice)}`}
              daysLeft={"NA"}
              pdfUrl={auction.pdfUrl}
              propertyType={auction.propertyType} // Now passing propertyType
            />
          </div>
        ))
      ) : (
        <div className="text-center py-10">
          <p className="text-xl font-semibold text-gray-700">
            🚫 No auctions found
          </p>
          <p className="text-gray-500">Try adjusting the filters or check back later.</p>
        </div>
      )}
    </div>
    </div>
  );
};

export default BankAuctionPage2;
